module.exports = __webpack_public_path__ + "img/image123.89675aea.jpg";